import React, { useEffect, useState } from "react";
import OtpInput from 'react18-input-otp';
import style from './style.module.css';
import FormGroup from "../FormGroup";

const InputOTP = (props) => {
    const [otp, setOtp] = useState('');
    const { separator = "", length = 6, isInputSecure = false, input: { onChange, value, onBlur }, label, required, meta } = props;
    useEffect(() => {
        setOtp(value)
    }, [value])

    const handleChange = (otpValue) => {
        setOtp(otpValue)
        onChange(otpValue)
        if (otpValue && otpValue.length === 6) {
            onBlur()
        }
    }

    return (
        <FormGroup
            meta={meta}
            label={label}
            required={required}
            value={value || <>&nbsp;</>}
            inputType="input"
            className="otpWrap"
        >
            <OtpInput
                value={otp}
                shouldAutoFocus={true}
                containerStyle={style.otpInputContainer}
                inputStyle={style.otpInput}
                onChange={handleChange}
                numInputs={length}
                separator={separator}
                isInputNum={true}
                isInputSecure={isInputSecure}
                focusStyle={style.otpInputFocus}
            />
        </FormGroup>
    )
}

export default InputOTP